import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when searching for the impact analysis id');

// eslint-disable-next-line import/prefer-default-export
export const searchImpactId = id => axios.get('/CsaImpact/GetCsaImpactByImpactAnalysisId', { params: { impactAnalysisId: id } })
    .then(r => r.data).catch(errorHandler);
